// Carrega categorias + posts do blog via API própria (/api/blog)
import { useState, useEffect } from 'react';
import { api } from '../lib/api';
import type { BlogPost, BlogCategory } from '../types/blog';
import { logger } from '../utils/logger';

interface PostsResponse {
  posts: BlogPost[];
}

interface CategoriesResponse {
  categories: BlogCategory[];
}

export const useBlog = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [categories, setCategories] = useState<BlogCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadBlog = async () => {
      try {
        const [postsRes, categoriesRes] = await Promise.all([
          api.get<PostsResponse>('/blog/posts?page=1&limit=50'),
          api.get<CategoriesResponse>('/blog/categories'),
        ]);
        setPosts(postsRes.posts ?? []);
        setCategories(categoriesRes.categories ?? []);
        setError(null);
      } catch (err) {
        logger.error('Error loading blog:', err);
        setError(err instanceof Error ? err : new Error('Erro ao carregar o blog'));
      } finally {
        setLoading(false);
      }
    };

    loadBlog();
  }, []);

  return {
    posts,
    categories,
    loading,
    error,
    refresh: () => setLoading(true) // mesmo padrão de useProducts
  };
};